import React from 'react';
import { useTheme } from '../../core/context/ThemeContext';

/**
 * PreviewBackground Component
 * 
 * V2: Direct theme-aware background wrapper for website preview.
 * Uses inline styles with !important to override any conflicting CSS.
 * Hooks directly into ThemeContext for reliable theme detection.
 */
export const PreviewBackground = ({ children, className = '', onScroll, ...props }) => {
  const { theme, isHydrated } = useTheme();
  
  // Use inline styles with !important to ensure they take precedence
  const backgroundStyle = {
    // Dark mode: Radial gradient from dark gray to black
    // Light mode: Solid white
    background: theme === 'dark' 
      ? 'radial-gradient(circle at center, #262626 0%, #000000 100%) !important' 
      : '#ffffff !important',
  };

  // Don't render until theme is hydrated to prevent flash
  if (!isHydrated) {
    return null;
  }

  return (
    <div 
      className={className}
      style={backgroundStyle}
      data-preview-bg={theme}
      onScroll={onScroll}
      {...props}
    >
      {children}
    </div>
  );
};

export default PreviewBackground;
